const URL = '/creditos';

const state = {
  selected: {
    id: null,
    cuenta_id: null,
    precio_id: null,
    periodo: null,
    fecha: null,
    kilos: 0,
    forma_pago_id: 1,
    pleno: 0,
  },
  edited: {
    id: null,
    cuenta_id: null,
    precio_id: null,
    periodo: null,
    fecha: null,
    kilos: 0,
    forma_pago_id: 1,
    pleno: 0,
  },
  loading: false,
  rules: {
    cuenta_id: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe existir una cuenta asociada',
    ],
    precio_id: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe existir un precio asociado',
    ],
    periodo: [
      v => !!v || 'Este campo es necesario',
    ],
    fecha: [
      v => !!v || 'Este campo es necesario',
    ],
    kilos: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe ser mayor a cero (0)',
    ],
    forma_pago_id: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe existir una forma de pago asociada',
    ],
  },
}

// GETTERS
const getters = {
  edited (state) {
    return state.edited
  },
  selected (state) {
    return state.selected
  },
  rules (state) {
    return state.rules
  },
  loading (state) {
    return state.loading
  },
  updatable (state) {
    return state.edited.id == state.selected.id && (
      state.edited.cuenta_id != state.selected.cuenta_id ||
      state.edited.precio_id != state.selected.precio_id ||
      state.edited.periodo != state.selected.periodo ||
      state.edited.fecha != state.selected.fecha ||
      state.edited.kilos != state.selected.kilos ||
      state.edited.forma_pago_id != state.selected.forma_pago_id
    )
  },
}

// ACTIONS
const actions = {
  onClearEdited ({ commit}) {
    commit('setEdited', {
      id: null,
      cuenta_id: null,
      precio_id: null,
      periodo: null,
      fecha: null,
      kilos: 0,
      forma_pago_id: 1,
      pleno: 0,
    })
  },
  onClearSelected ({ commit}) {
    commit('setSelected', {
      id: null,
      cuenta_id: null,
      precio_id: null,
      periodo: null,
      fecha: null,
      kilos: 0,
      forma_pago_id: 1,
      pleno: 0,
    })
  },
  onSave ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.post(URL, state.edited)
        .then(response => {
          // const aux = {
          //   id: response.data.data.id,
          //   cuenta_id: response.data.data.cuenta_id,
          //   precio_id: response.data.data.precio_id,
          //   periodo: response.data.data.periodo,
          //   fecha: response.data.data.fecha,
          //   kilos: response.data.data.kilos,
          //   forma_pago_id: response.data.data.forma_pago_id,
          //   pleno: response.data.data.pleno,
          // }
          // commit('setSelected', aux)
          commit('ResponseHTTP/addSuccess', 'El credito pleno fue registrado.', { root: true })
          resolve(response.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error. No se registro el credito pleno', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
}

// MUTATIONS
const mutations = {
  setEdited (state, payload) {
    state.edited = Object.assign({}, payload)
  },
  setSelected (state, payload) {
    state.selected = Object.assign({}, payload)
  },
  setLoading (state, payload) {
    state.loading = payload
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
